/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'progress-changes': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.146 3.16a.47.47 0 01.638-.063l.07.063 6 6.454c.173.19.192.484.057.696l-.057.076-6 6.454a.471.471 0 01-.708 0 .583.583 0 01-.057-.696l.057-.075L9.793 10 4.146 3.931a.583.583 0 01-.057-.696l.057-.075zM14.068 3.774c-.21.42-.234.932-.234 1.26v.063h3.33v-.062c0-.349-.027-.858-.234-1.272-.185-.368-.558-.75-1.432-.75-.87-.001-1.244.387-1.43.761zm3.096 2.336l-3.33-.001.002 8.857 1.666 2.022 1.664-2.021-.002-8.857zm-3.81-2.858C13.711 2.533 14.377 2 15.498 2c1.117 0 1.785.52 2.144 1.236.335.67.355 1.424.355 1.798L18 14.971c0 .274-.09.525-.244.712l-1.665 2.02c-.325.396-.853.396-1.178 0l-1.666-2.022a1.119 1.119 0 01-.244-.71L13 5.032c0-.357.02-1.11.354-1.781z" _fill="#1D3861"/>'
  }
})
